import {
  fetchReceiversFiltered,
  getBodyPayloadFiltered,
} from 'components/Receivers/func';
import { BUSINESS_OF_RECEIVER_TYPE } from 'constants';
import { checkMaintenance } from 'helpers/maintenance';
import { searchTextValid } from 'helpers';
import useAuth from 'hooks/useAuth';
import useDetectEndpointVisibleOnScreen from 'hooks/useDetectEndpointVisibleOnScreen';
import useThrottle from 'hooks/useThrottle';
import { useEffect } from 'react';

const PaginationMobile = ({
  applyFiltered,
  searchValue,
  currentPage,
  setCurrentPage,
  receivers,
  setReceivers,
  currentTab,
  isSearched,
  totalPages,
}) => {
  const { token } = useAuth();
  const { throttle } = useThrottle(1);
  const isIntersecting = useDetectEndpointVisibleOnScreen();

  const fetchReceiversPagination = (page) => {
    throttle(() => {
      if (!searchTextValid(searchValue)) return;

      try {
        let bodyPayload = getBodyPayloadFiltered(applyFiltered);

        bodyPayload = {
          ...bodyPayload,
          name: isSearched ? searchValue : '',
          ...(currentTab === 1 && { gender: BUSINESS_OF_RECEIVER_TYPE }),
        };

        fetchReceiversFiltered({
          token,
          body: bodyPayload,
          page,
          receivers,
          setReceivers,
          setCurrentPage,
        });
      } catch (error) {
        checkMaintenance(error);
        console.error(error?.message);
      }
    });
  };
  const handleNextPage = (page) => {
    if (totalPages === currentPage) return;
    fetchReceiversPagination(page);
  };

  useEffect(() => {
    if (isIntersecting) {
      handleNextPage(currentPage + 1);
    }
  }, [isIntersecting, currentPage]);

  return null;
};

export default PaginationMobile;
